import script from "./EnrolFormation.vue?vue&type=script&setup=true&lang=ts"
export * from "./EnrolFormation.vue?vue&type=script&setup=true&lang=ts"

import "./EnrolFormation.vue?vue&type=style&index=0&id=5a88e13b&lang=scss"

const __exports__ = script;

export default __exports__